exports = module.exports = require("../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .scrollhost::-webkit-scrollbar {\n\n\tbackground-color: #F5F5F5;\n}\n   */\n   .scrollhost::-webkit-scrollbar-track\n{\n\t/* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tborder-radius: 10px;\n\tbackground-color: #F5F5F5; */\n}\n\n.scrollhost::-webkit-scrollbar\n{\n\twidth: 12px;\n}\n\n.scrollhost::-webkit-scrollbar-thumb\n{\n\tborder-radius: 10px;\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n\tbackground-color: #74858a;\n}\n#circle-example * {\n\toutline: none;\n}", ""]);

// exports
